import React from 'react';
import { useParams } from 'react-router-dom';
import GeneralForm from './GeneralForm';
import ContactFormConfirmation from './ContactFormConfirmation';

export const ContactForm = () => {
  const { slug } = useParams();
  return slug ? <ContactFormConfirmation /> : <GeneralForm />;
};
